export enum BadgeEnum {
  MADEIN = 'MADEIN'
}
